/**
 * Ephemeral slice propagating a "select the freshly persisted purchased
 * itinerary" request from the ticket purchase wizard back to the itinerary
 * planner (same producer/consumer shape as {@link itineraryOfferRefreshSlice}).
 */

import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";

/**
 * Last purchased-itinerary open request.
 */
export interface PurchasedItineraryOpenState {

    /** `itinerary.id` of the persisted purchased entry to open, `null` before any request. */
    "itineraryId": string | null;

    /** Incremented on every request so subscribers react even when the same itinerary is opened twice. */
    "revision": number;
}

/** Default state: nothing requested yet. */
export const PURCHASED_ITINERARY_OPEN_DEFAULT: PurchasedItineraryOpenState = {
    "itineraryId": null,
    "revision":    0,
};

/**
 * Slice written by the ticket purchase confirmation after the purchased entry
 * is persisted (`upsertPurchasedItinerary`) and consumed by the itinerary list
 * (`usePurchasedItineraryOpen`), which resolves the persisted entry and selects
 * it exactly like a manual click on the saved list.
 */
export const purchasedItineraryOpenSlice = defineEphemeralSlice<PurchasedItineraryOpenState>( {
    "key":     "purchasedItineraryOpen",
    "default": () => PURCHASED_ITINERARY_OPEN_DEFAULT,
} );
